import { render, staticRenderFns } from "./EventClassSelect.vue?vue&type=template&id=5f5f0da2&scoped=true"
import script from "./EventClassSelect.vue?vue&type=script&lang=js"
export * from "./EventClassSelect.vue?vue&type=script&lang=js"
import style0 from "./EventClassSelect.vue?vue&type=style&index=0&id=5f5f0da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f0da2",
  null
  
)

export default component.exports